module.exports = __webpack_public_path__ + "img/abBanner-id.28c63d34.png";